/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum WorkspaceInviteStatus {
  PENDING = 'pending',
  ALREADY_MEMBER = 'already_member',
  AUTO_ACCEPTED = 'auto_accepted',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  WITHDRAWN = 'withdrawn',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
  FAILED = 'failed',
}
